import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { deviceEnvironmentId } from 'src/app/core/enums/device-environment-id';
import { QueryModel } from 'src/app/core/models/query.model';
import { CloverService } from 'src/app/core/services/clover.service';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SendHelpService } from 'src/app/core/services/send-help.services';
@Component({
  selector: 'app-help-view',
  templateUrl: './help-view.component.html',
  styleUrls: ['./help-view.component.scss']
})
export class HelpViewComponent implements OnInit {
  @ViewChild('phoneInput', { static: true }) phoneInput: ElementRef;
  @ViewChild('getFile') getFile: ElementRef;
  @ViewChild('motivoDeConsultaSelect') selectConsulta: MatSelect;
  @ViewChild('formDirective') private formDirective: NgForm;

  phoneNumber: string = '+54 9 11 5640 9598';
  consultaActual;
  fileText: string = 'Puedes adjuntar archivos png, jpg o pdf';
  file: FileList;
  motivoSelect: string = '';
  form: UntypedFormGroup;
  motivosConsulta;
  maxFileSize = 1000000;
  loading: boolean = false;
  sended: boolean = false;
  environment: string = '';
  terminalId: string = '';
  version: string = require('../../../../package.json').version;
  deviceEnvironmentId = deviceEnvironmentId;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private sendHelService: SendHelpService,
    private translateService: TranslateService,
    private nativeBridgeService: NativeBridgeService,
    private cloverService: CloverService
  ) {}

  get motivo() {
    return this.form.get('motivo');
  }

  get comentario() {
    return this.form.get('comentario');
  }
  motivosLoading: boolean = false;
  async ngOnInit() {
    this.environment = this.nativeBridgeService.getEnvironment();
    if (this.environment == this.deviceEnvironmentId.CLOVER) {
      this.terminalId = this.cloverService.getTerminalId();
    }
    this.form = this.formBuilder.group({
      motivo: new UntypedFormControl(null, { validators: Validators.required }),
      comentario: new UntypedFormControl('', { validators: Validators.required })
    });

    this.motivosLoading = true;
    this.motivosLoading = false;

    this.comentario.valueChanges.subscribe((val) => {
      if (val && val.trim().length > 0) {
        this.comentario.setErrors({});
        this.comentario.updateValueAndValidity({ onlySelf: false, emitEvent: false });
      } else {
        this.comentario.setErrors({ incorrect: true });
      }
    });
  }

  selectionChangeConsulta() {
    this.consultaActual = this.selectConsulta.value;
  }

  openFile() {
    (this.getFile.nativeElement as HTMLInputElement).click();
  }

  async submit(form) {
    this.loading = true;
    try {
      if (this.comentario.value.trim().length > 0) {
        let consulta = new QueryModel();
        consulta.motivoId = this.motivo.value;
        consulta.descripcion = this.comentario.value;
        this.resetForm();
        await this.sendHelService.sendQuery(consulta);
        this.consultaActual = this.selectConsulta.value = [];
        this.motivoSelect = '';
        this.fileText = 'Puedes adjuntar archivos png, jpg o pdf';
        this.loading = false;
        this.sended = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }

  resetForm() {
    this.form.reset();
  }

  deleteFile() {
    this.getFile.nativeElement.value = null;
    this.fileText = 'Puedes adjuntar archivos png, jpg o pdf';
  }

  async handleFileInput(fileList: FileList) {
    this.file = this.validateFile(fileList[0]) ? fileList : null;
  }

  private validateFile(file: File) {
    if (file.size > this.maxFileSize) {
      throw new Error(this.translate('pages.profile.messages.errors.img_file_size_1mb'));
    }
    return true;
  }

  goToWhatsapp() {
    window.open('https://wa.me/+5491156409598');
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }
}
